export const CHECK_USER_REQUEST = '/api/v1/auth/check/';
export const LOGOUT_REQUEST = '/api/v1/auth/logout/';
export const GET_CURRENT_USER = '/api/v1/user/current/';
export const MAKE_USER_REQUEST = '/api/v1/user/';
export const PASSWORD_RESET_INFO = '/api/v1/password/info/';
export const PASSWORD_RESET_SUBMIT = '/api/v1/password/reset/';
export const PAGE_CSRF_URL = '/api/v1/page/csrf/';
export const AUTH_LOGIN_URL = '/api/v1/auth/login/';

export const SEARCH_PRODUCT_REQUESTS = '/api/v1/product/search/';
export const MAKE_CATEGORY_REQUEST = '/api/v1/category';
export const MAKE_MANUFACTURER_REQUEST = '/api/v1/manufacturer/';

export const GET_INFO_FTS = '/api/v1/customer/fts/';
export const MAKE_CUSTOMER_REQUEST = '/api/v1/customer/';
export const MAKE_DELIVERY_REQUEST = '/api/v1/delivery/';

export const MAKE_PRODUCT_REQUEST = '/api/v1/product';
export const MAKE_ORDER_REQUEST = '/api/v1/order/';
export const MAKE_REQUEST = '/api/v1/request/';
export const GET_STOCKS = '/api/v1/stock/';
export const CONFIGS_URL = '/api/v1/application/config/';

export const getFetchRequest = (url, succesCallback, errorCallback, withoutJSON=false) => {
    const token = localStorage.getItem('token');
    const headers = {
        "Content-Type": "application/json", 
    };
    if(token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    fetch(`${url}`, {
        credentials: 'include',
        method: 'GET',
        headers,
    }).then(response => {
        if(withoutJSON||!response.ok) {
            return response;
        } else {
            return response.json();
        }
    }).then(response => {
        succesCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const getDatasheetRequest = (url, succesCallback, errorCallback) => {
    fetch(`${url}`, {
        method: 'GET',
    }).then(response => {
        succesCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const postFetchRequest = (url, body, succesCallback, errorCallback, withoutJSON=false) => {
    const token = localStorage.getItem('token');
    const headers = {
        "Content-Type": "application/json", 
    };
    if(token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    fetch(`${url}`, {
        credentials: 'include',
        method: 'POST',
        headers,
        body: JSON.stringify(body),
    }).then(response => {
        if(body&&!withoutJSON&&response.ok) {
            return response.json();
        } else {
            return response;
        }
    }).then(response => {
        succesCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const postFetchRequestWithSignal = (url, body, succesCallback, errorCallback, controller, withoutJSON=false) => {
    const token = localStorage.getItem('token');
    const headers = {
        "Content-Type": "application/json", 
    };
    if(token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    fetch(`${url}`, {
        credentials: 'include',
        method: 'POST',
        signal: controller.signal,
        headers,
        body: JSON.stringify(body),
    }).then(response => {
        if(body&&!withoutJSON&&response.ok) {
            return response.json();
        } else {
            return response;
        }
    }).then(response => {
        succesCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const deleteFetchRequest = (url, body, succesCallback, errorCallback, withoutJSON=false) => {
    const token = localStorage.getItem('token');
    const headers = {
        "Content-Type": "application/json", 
    };
    if(token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    fetch(`${url}`, {
        credentials: 'include',
        method: 'DELETE',
        headers,
        body: JSON.stringify(body),
    }).then(response => {
        if(body&&!withoutJSON&&response.ok) {
            return response.json();
        } else {
            return response;
        }
    }).then(response => {
        succesCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};

export const putFetchRequest = (url, body, succesCallback, errorCallback, withoutJSON=false) => {
    const token = localStorage.getItem('token');
    const headers = {
        "Content-Type": "application/json", 
    };
    if(token) {
        headers["Authorization"] = `Bearer ${token}`;
    }
    fetch(`${url}`, {
        credentials: 'include',
        method: 'PUT',
        headers,
        body: JSON.stringify(body),
    }).then(response => {
        if(body&&!withoutJSON&&response.ok) {
            return response.json();
        } else {
            return response;
        }
    }).then(response => {
        succesCallback(response);
    }).catch(e => {
        errorCallback(e);
    });
};